(function () {
	'use strict';

	try{if(typeof document != 'undefined'){var elementStyle = document.createElement('style');elementStyle.appendChild(document.createTextNode("._bar_fqoj7_1 {\n    box-sizing: border-box;\n    display: block;\n    height: 6px;\n    max-width: 100%;\n    border-radius: 3px;\n}\n\n._notDone_fqoj7_9 {\n    width: 100%;\n    background-color: var(--axa-fr-button-inverse-active-bg);\n}\n\n._completion_fqoj7_14 {\n    background-color: var(--axa-fr-bg-secondary);\n    transition: width 0.5s ease-out;\n}\n\nli[data-anim-wait=\"true\"] ._completion_fqoj7_14 {\n    transition: width 0.5s 0.5s ease-out;\n}\n._stepTitle_o8310_1 {\n    /*\n        Hide the title on mobile.\n        It will be the parent responsibility to display it on mobile.\n\n        The title and progress bar are 'merged' together in this component to respect the design system.\n     */\n    display: none;\n\n    margin: 0;\n    margin-bottom: var(--axa-fr-spacing-01);\n    padding: 0;\n\n    font-family: var(--font-family);\n    font-size: 1.6rem;\n    font-weight: 400;\n    text-align: center;\n    line-height: 2.4rem;\n}\n\n._inactive_o8310_21 {\n    color: var(--axa-fr-text-secondary);\n}\n\n._active_o8310_25,\n._done_o8310_26 {\n    color: var(--axa-fr-text-primary);\n}\n\n._active_o8310_25 {\n    font-weight: 600;\n}\n\n /* 'sr-only' equal to 'screen reader only' */\n._sr-only_o8310_35 {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0,0,0,0);\n    white-space: nowrap;\n    border: 0;\n}\n\n@media only screen and (min-width: 668px) {\n    ._stepTitle_o8310_1 {\n        display: block;\n    }\n}\n._mobileStepTitle_1kfyg_1 {\n    font-family: var(--font-family);\n    font-size: 1.8rem;\n    font-weight: 400;\n    text-align: center;\n    line-height: 2.6rem;\n    display: inline-block;\n    margin: 0 0 var(--axa-fr-spacing-01);\n    width: 100%;\n    padding: 0;\n    color: var(--axa-fr-text-secondary);\n}\n\n._stepsList_1kfyg_14 {\n    display: flex;\n    gap: var(--axa-fr-spacing-01);\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n._step_1kfyg_14 {\n    width: 100%;\n}\n\n@media only screen and (min-width: 668px) {\n    ._stepsList_1kfyg_14 {\n        gap: var(--axa-fr-spacing-02);\n    }\n\n    ._mobileStepTitle_1kfyg_1 {\n        display: none;\n    }\n}\n._stepper_kgnpd_1 {\n    margin-block-end: 32px;\n}\n\n@media only screen and (min-width: 668px) {\n    ._stepper_kgnpd_1 {\n        margin-block-end: 40px;\n    }\n}"));document.head.appendChild(elementStyle);}}catch(e){console.error('vite-plugin-css-injected-by-js', e);}

})();
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useId, useState, useEffect } from 'react';
import { MIN_STEPS } from '@axafr-btc-ds/progress-bar';

const bar = "_bar_fqoj7_1";
const notDone = "_notDone_fqoj7_9";
const completion = "_completion_fqoj7_14";
const styles$3 = {
	bar: bar,
	notDone: notDone,
	completion: completion
};

const PROGRESS_BAR_MIN_PERCENTAGE = 0;
const PROGRESS_BAR_MAX_PERCENTAGE = 100;
function ProgressBar({ completion = 0, labelledby }) {
  const boundedCompletion = limitMinMaxCompletion(completion);
  return /* @__PURE__ */ jsx(
    "span",
    {
      role: "progressbar",
      "aria-labelledby": labelledby,
      "aria-valuemin": PROGRESS_BAR_MIN_PERCENTAGE,
      "aria-valuenow": boundedCompletion,
      "aria-valuemax": PROGRESS_BAR_MAX_PERCENTAGE,
      className: classNames(styles$3.bar, styles$3.notDone),
      children: /* @__PURE__ */ jsx(
        "span",
        {
          style: { width: `${boundedCompletion}%` },
          className: classNames(styles$3.bar, styles$3.completion)
        }
      )
    }
  );
}
function limitMinMaxCompletion(completion) {
  if (completion < PROGRESS_BAR_MIN_PERCENTAGE) {
    return PROGRESS_BAR_MIN_PERCENTAGE;
  }
  if (completion > PROGRESS_BAR_MAX_PERCENTAGE) {
    return PROGRESS_BAR_MAX_PERCENTAGE;
  }
  return completion;
}

const stepTitle = "_stepTitle_o8310_1";
const inactive = "_inactive_o8310_21";
const active = "_active_o8310_25";
const done = "_done_o8310_26";
const styles$2 = {
	stepTitle: stepTitle,
	inactive: inactive,
	active: active,
	done: done,
	"sr-only": "_sr-only_o8310_35"
};

function computeStepTitleStyleFor(current, completion = 0) {
  return {
    [styles$2.stepTitle]: true,
    [styles$2.active]: current,
    [styles$2.done]: completion >= PROGRESS_BAR_MAX_PERCENTAGE,
    [styles$2.inactive]: !current && completion < PROGRESS_BAR_MAX_PERCENTAGE
  };
}
function computeCompletion(rawCompletion, isInProgress) {
  if (isInProgress) {
    return rawCompletion;
  }
  if (rawCompletion === PROGRESS_BAR_MAX_PERCENTAGE) {
    return PROGRESS_BAR_MAX_PERCENTAGE;
  }
  return PROGRESS_BAR_MIN_PERCENTAGE;
}

function NavigationStep({ children, completion = 0, current }) {
  const id = useId();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    current && /* @__PURE__ */ jsx("span", { className: styles$2["sr-only"], children: "Étape en cours :" }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(computeStepTitleStyleFor(Boolean(current), completion)),
        id,
        children
      }
    ),
    /* @__PURE__ */ jsx(
      ProgressBar,
      {
        completion: computeCompletion(completion, Boolean(current)),
        labelledby: id
      }
    )
  ] });
}

const Step = ({ children, title }) => {
  return /* @__PURE__ */ jsx(Fragment, { children: children ?? title });
};

const mobileStepTitle = "_mobileStepTitle_1kfyg_1";
const stepsList = "_stepsList_1kfyg_14";
const step = "_step_1kfyg_14";
const styles$1 = {
	mobileStepTitle: mobileStepTitle,
	stepsList: stepsList,
	step: step
};

const NavigationStepper = ({
  children,
  activeStep = 0,
  stepProgress,
  className
}) => {
  const [lastActiveStep, setLastActiveStep] = useState(activeStep);
  const stepsTitles = extractStepsTitlesFrom(children);
  useEffect(() => {
    setLastActiveStep(activeStep);
  }, [activeStep]);
  if (stepsTitles.length < MIN_STEPS) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className,
      "aria-label": "Progression du parcours",
      children: [
        /* @__PURE__ */ jsx("span", { className: styles$1.mobileStepTitle, children: stepsTitles[activeStep] }),
        /* @__PURE__ */ jsx("ol", { className: styles$1.stepsList, children: stepsTitles.map((step, index) => /* @__PURE__ */ jsx(
          "li",
          {
            "aria-label": step.props.title,
            className: styles$1.step,
            "aria-current": activeStep === index,
            "data-anim-wait": activeStep === index && activeStep !== lastActiveStep,
            children: /* @__PURE__ */ jsx(
              NavigationStep,
              {
                current: activeStep === index,
                completion: getCompletionFor(index, activeStep, stepProgress),
                children: step
              }
            )
          },
          `${index}-${step.props.title}`
        )) })
      ]
    }
  );
};
function extractStepsTitlesFrom(steps) {
  if (!steps) {
    return [];
  }
  return steps.filter((step) => Boolean(step.props.title));
}
function getCompletionFor(index, activeStep, completion) {
  if (index === activeStep) {
    return completion;
  }
  if (index < activeStep) {
    return PROGRESS_BAR_MAX_PERCENTAGE;
  }
  return PROGRESS_BAR_MIN_PERCENTAGE;
}

const stepper = "_stepper_kgnpd_1";
const styles = {
	stepper: stepper
};

const Stepper = ({ className, data, path, steps }) => {
  const progressData = data[path];
  if (!progressData) {
    return null;
  }
  return /* @__PURE__ */ jsx("header", { className: styles.stepper, children: /* @__PURE__ */ jsx(
    NavigationStepper,
    {
      className,
      activeStep: progressData.activeStep,
      stepProgress: progressData.stepProgress,
      children: steps.map((step) => /* @__PURE__ */ jsx(Step, { title: step }, step))
    }
  ) });
};

export { NavigationStep, NavigationStepper, PROGRESS_BAR_MAX_PERCENTAGE, PROGRESS_BAR_MIN_PERCENTAGE, ProgressBar, Step, Stepper };
